<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :closable="false"
    :maskClosable="false"
    width="420px"
    :bodyStyle="{ padding: 0, borderRadius: '8px' }"
    @cancel="close"
  >
    <div class="add-ref">
      <div class="add-ref-title">添加至</div>
      <div class="add-ref-list">
        <div
          v-for="g in groups"
          :key="g.name"
          class="add-ref-item"
          @click="selected = g.name"
        >
          <div class="add-ref-radio" :class="{ on: selected === g.name }">
            <span v-if="selected === g.name" class="add-ref-check">✓</span>
          </div>
          <div class="add-ref-name">{{ g.name }}（{{ g.count }}）</div>
        </div>
      </div>
      <div v-if="showNewGroup" class="add-ref-new-row">
        <input v-model="newGroupName" class="add-ref-input" placeholder="请输入分组名称" @keyup.enter="submitNewGroup" />
        <div class="add-ref-new-ok" @click="submitNewGroup">添加</div>
        <div class="add-ref-new-cancel" @click="cancelNewGroup">取消</div>
      </div>
      <div class="add-ref-foot">
        <div class="add-ref-new" @click="showAddGroup">新增分组</div>
        <div class="add-ref-ok" :class="{ disabled: !selected || saving }" @click="confirm">确认</div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { message } from 'ant-design-vue'
import { requestHttpGet, requestHttpPostByOnline } from '@/api/main'
import apiUrl from '@/utils/config'

const DEFAULT_GROUPS = ['家装效果图', '工装效果图']
const LS_KEY = 'pcim_ref_groups'

export default {
  name: 'AddToReference',
  props: {
    visible: { type: Boolean, default: false },
    picUrl: { type: String, default: '' },
  },
  data() {
    return {
      groups: [],
      selected: '',
      saving: false,
      showNewGroup: false,
      newGroupName: '',
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.showNewGroup = false
        this.newGroupName = ''
        this.loadGroups()
      }
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    getExtraGroups() {
      try {
        const raw = localStorage.getItem(LS_KEY)
        const arr = raw ? JSON.parse(raw) : []
        return Array.isArray(arr) ? arr.filter(Boolean) : []
      } catch (e) {
        return []
      }
    },
    saveExtraGroups(names) {
      localStorage.setItem(LS_KEY, JSON.stringify(names))
    },
    async loadGroups() {
      const countMap = {}
      try {
        const res = await requestHttpGet(apiUrl + '/admin-api/product/reference/slas')
        const list = (res && res.data) || []
        list.forEach((e) => {
          const name = e.referenceName || '未分组'
          countMap[name] = (countMap[name] || 0) + 1
        })
      } catch (e) {
        console.error(e)
      }
      const names = [...DEFAULT_GROUPS]
      this.getExtraGroups().forEach((n) => {
        if (!names.includes(n)) names.push(n)
      })
      Object.keys(countMap).forEach((n) => {
        if (!names.includes(n)) names.push(n)
      })
      this.groups = names.map((name) => ({
        name,
        count: countMap[name] || 0,
      }))
      if (!this.selected || !names.includes(this.selected)) {
        this.selected = names[0] || ''
      }
    },
    showAddGroup() {
      this.showNewGroup = true
      this.newGroupName = ''
    },
    cancelNewGroup() {
      this.showNewGroup = false
      this.newGroupName = ''
    },
    submitNewGroup() {
      const name = (this.newGroupName || '').trim()
      if (!name) {
        message.warning('请输入分组名称')
        return
      }
      if (this.groups.some((g) => g.name === name)) {
        message.warning('分组已存在')
        return
      }
      const extras = this.getExtraGroups()
      if (!extras.includes(name)) {
        extras.push(name)
        this.saveExtraGroups(extras)
      }
      this.groups.push({ name, count: 0 })
      this.selected = name
      this.showNewGroup = false
      this.newGroupName = ''
    },
    async confirm() {
      if (!this.selected || this.saving) return
      if (!this.picUrl) {
        message.error('未获取到图片地址')
        return
      }
      this.saving = true
      try {
        const res = await requestHttpPostByOnline(apiUrl + '/admin-api/product/reference/designer-create', {
          picUrls: this.picUrl,
          name: this.selected,
          status: 0,
          applyStatus: 2,
        })
        if (res && res.code === 0) {
          message.success('已添加到参考图库')
          this.$emit('success')
          this.close()
        } else {
          message.error((res && res.msg) || '添加失败')
        }
      } catch (e) {
        console.error(e)
        message.error('添加失败')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.add-ref {
  padding: 24px 28px 20px;
}
.add-ref-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin-bottom: 20px;
}
.add-ref-list {
  max-height: 280px;
  overflow-y: auto;
}
.add-ref-item {
  display: flex;
  align-items: center;
  height: 48px;
  cursor: pointer;
}
.add-ref-radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.add-ref-radio.on {
  border-color: #ff4040;
  background: #ff4040;
  color: #fff;
}
.add-ref-check {
  font-size: 12px;
  line-height: 1;
}
.add-ref-name {
  font-size: 14px;
  color: #333;
}
.add-ref-new-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}
.add-ref-input {
  flex: 1;
  height: 32px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 13px;
}
.add-ref-new-ok {
  color: #ff4040;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}
.add-ref-new-cancel {
  color: #999;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}
.add-ref-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}
.add-ref-new {
  color: #4a90e2;
  font-size: 14px;
  cursor: pointer;
}
.add-ref-ok {
  min-width: 88px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background: #ff4040;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  padding: 0 20px;
}
.add-ref-ok.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
